import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "react-dates/initialize";
import {
  DateRangePicker,
  SingleDatePicker,
  isInclusivelyBeforeDay,
  isInclusivelyAfterDay
} from "react-dates";
import "react-dates/lib/css/_datepicker.css";

class ReactDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment(this.props.startDate),
      endDate: moment(this.props.endDate),
      value: null,
      arrayValue: [],
      initVisibleMonth: moment(this.props.endDate),
      showInfo: false
    };
    this.dateChange = this.dateChange.bind(this);
    this.renderCalendarInfo = this.renderCalendarInfo.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.startDate !== this.props.startDate) {
      this.setState({
        startDate: moment(this.props.startDate)
      });
    }
    if (prevProps.endDate !== this.props.endDate) {
      this.setState({
        endDate: moment(this.props.endDate)
      });
    }
  }

  dateChange(startDate, endDate) {
    if (startDate !== null && endDate !== null) {
      this.props.updateDates(
        moment(startDate).format("YYYY-MM-DD"),
        moment(endDate).format("YYYY-MM-DD")
      );
    }
  }

  renderCalendarInfo() {
    let minDate = "";
    const maxDate = moment(this.props.calendarEndDate).format("MM/DD/YYYY");
    if (this.props.numberOfMonths) {
      minDate = moment(this.props.calendarEndDate).subtract(this.props.numberOfMonths, "month");
    } else if (this.props.minDate) {
      minDate = moment(this.props.minDate);
    } else if (this.props.firstDataDate) {
      minDate = moment(this.props.firstDataDate);
    }

    minDate = minDate && minDate.format("MM/DD/YYYY");
    return (
      <>
        {minDate ? (
          <div style={{ color: "white", padding: "10px", fontWeight: "bold" }}>
            <span className="glyphicon glyphicon-info-sign" />
            {` Date should be in range: ${minDate} - ${maxDate}`}
          </div>
        ) : (
          ""
        )}
      </>
    );
  }

  doFocusChange(type) {
    if (type === "endDate") {
      this.setState({
        initVisibleMonth: moment(this.props.endDate)
      });
    } else if (type === "startDate") {
      this.setState({
        initVisibleMonth: moment(this.props.startDate)
      });
    }
  }

  isOutsideRange = (day) => {
    let calc;
    const calendarEndDate = moment(this.props.calendarEndDate);
    const minDate = moment(this.props.minDate);

    if (this.props.minDate !== undefined) {
      calc = day.isBefore(minDate, "day") || day.isAfter(calendarEndDate, "day");
    } else if (this.props.numberOfMonths !== undefined) {
      calc =
        !isInclusivelyBeforeDay(day, moment(this.props.calendarEndDate)) ||
        !isInclusivelyAfterDay(
          day,
          moment(this.props.calendarEndDate).subtract(this.props.numberOfMonths, "month")
        );
    } else if (this.props.firstDataDate !== undefined) {
      calc =
        !isInclusivelyBeforeDay(day, moment(this.props.calendarEndDate)) ||
        !isInclusivelyAfterDay(day, moment(this.props.firstDataDate));
    } else {
      calc = !isInclusivelyBeforeDay(day, moment(this.props.calendarEndDate));
    }

    return calc;
  };

  render() {
    return (
      <div>
        {this.props.isRangePicker ? (
          <DateRangePicker
            calendarInfoPosition="top"
            renderCalendarInfo={this.renderCalendarInfo}
            startDate={this.state.startDate} // momentPropTypes.momentObj or null,
            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
            endDate={this.state.endDate} // momentPropTypes.momentObj or null,
            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
            onDatesChange={({ startDate, endDate }) => this.dateChange(startDate, endDate)} // PropTypes.func.isRequired,
            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={(focusedInput) => {
              this.doFocusChange(focusedInput), this.setState({ focusedInput: null });

              // hack to re-render the calendar at correct month based on date click.
              setTimeout(() => {
                this.setState({ focusedInput });
              }, 1);
            }} // PropTypes.func.isRequired,
            initialVisibleMonth={() => this.state.initVisibleMonth}
            showDefaultInputIcon={this.props.showDefaultInputIcon}
            isOutsideRange={this.isOutsideRange}
            minimumNights={0}
            disabled={this.props.disabled}
          />
        ) : (
          <SingleDatePicker
            calendarInfoPosition="top"
            renderCalendarInfo={this.renderCalendarInfo}
            date={this.state.startDate} // momentPropTypes.momentObj or null
            onDateChange={(date) => this.dateChange(date, date)} // PropTypes.func.isRequired
            focused={this.state.focused} // PropTypes.bool
            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
            id="your_unique_id" // PropTypes.string.isRequired,
            showDefaultInputIcon
            isOutsideRange={this.isOutsideRange}
            disabled={this.props.disabled}
          />
        )}
      </div>
    );
  }
}

ReactDatePicker.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  minDate: PropTypes.string,
  updateDates: PropTypes.func,
  isRangePicker: PropTypes.bool,
  calendarEndDate: PropTypes.string,
  numberOfMonths: PropTypes.number,
  firstDataDate: PropTypes.any,
  showDefaultInputIcon: PropTypes.bool,
  disabled: PropTypes.bool
};

ReactDatePicker.defaultProps = {
  disabled: false
};

export default ReactDatePicker;
